import { useState, useEffect } from 'react';
import { compose } from 'redux';
import moment from 'moment';
import withStyles from '@material-ui/styles/withStyles';
import FieldActivityLogsTable from 'features/fields/activityLogs/FieldActivityLogsTable';
import FieldActivityLogsGanttChart from 'features/fields/activityLogs/FieldActivityLogsGanttChart';
import ActivityLogFilter from 'features/wells/overview/activityLog/ActivityLogFilter';
import {
  ACTIVITY_VIEWS,
  Filters,
  InitialFormValues,
} from 'features/wells/overview/activityLog/helpers/activityLog.constants';
import { filterFieldActivityLogs } from 'features/wells/overview/activityLog/helpers/activityLog.actions';
import { getFieldActivityLogsFromState } from 'features/wells/overview/activityLog/helpers/activityLog.selector';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { useCallback } from 'react';
import { LoadingOverlay } from 'altus-ui-components';
import { isMomentObject } from 'features/wells/overview/activityLog/helpers/activityLog.validators';

const FieldActivityLogsContainer = ({
  classes,
  fieldId,
  dataState,
  activityLogs,
  disptachFilterActivityLogs,
  selectedView,
}) => {
  const [activityLogsFromState, setActivityLogsFromState] = useState();
  const [filterFormValues, setFilterFormValues] = useState(InitialFormValues);

  useEffect(() => {
    setActivityLogsFromState(activityLogs);
  }, [activityLogs]);

  useEffect(() => {
    disptachFilterActivityLogs(fieldId, InitialFormValues);
  }, [disptachFilterActivityLogs, fieldId]);

  const onFiltersChange = useCallback(
    (formValues) => {
      const filters = {
        [Filters.NAME]: formValues.name,
        [Filters.STATUS]:
          formValues.status instanceof Number ||
          typeof formValues.status === 'number'
            ? [formValues.status]
            : [],
        [Filters.FROM]: isMomentObject(formValues.from)
          ? formValues.from.format()
          : moment(formValues.from).format(),
        [Filters.TO]: isMomentObject(formValues.to)
          ? formValues.to.format()
          : moment(formValues.to).format(),
      };
      setFilterFormValues(filters);
      disptachFilterActivityLogs(fieldId, filters);
    },
    [disptachFilterActivityLogs, fieldId],
  );

  return (
    <>
      <Grid item container paddingTop={2} paddingLeft={2} paddingRight={2}>
        <Grid xs={7} item>
          <ActivityLogFilter
            onSubmit={onFiltersChange}
            initialValues={InitialFormValues}
          />
        </Grid>
        <Grid xs={12} item className={classes.activityTable}>
          {selectedView === ACTIVITY_VIEWS.CHART ? (
            <FieldActivityLogsGanttChart
              activityLogs={activityLogsFromState}
              filter={filterFormValues}
            />
          ) : (
            <FieldActivityLogsTable activityLogs={activityLogsFromState} />
          )}
        </Grid>
      </Grid>
      <LoadingOverlay dataState={dataState} />
    </>
  );
};

const styles = (theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  activityTable: {
    scrollY: 'auto',
  },
});

export default compose(
  connect(
    (state) => ({
      activityLogs: getFieldActivityLogsFromState(state),
    }),
    {
      disptachFilterActivityLogs: filterFieldActivityLogs,
    },
  ),
  withStyles(styles),
)(FieldActivityLogsContainer);
